// /**
//  * Warwhouse - Edit
//  */

// React
import React, { useState } from 'react';

// react hook form
import { useForm } from 'react-hook-form';

// UI
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import {
  TextField,
  Grid,
  Button,
  CircularProgress,
  Typography,
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPhoneOutline,
  mdiCounter,
  mdiCalendar,
  mdiCalendarClock,
  mdiAccountTieOutline,
  mdiHomeCityOutline,
  mdiMapMarkerOutline,
} from '@mdi/js';

// Client SDK
import Client from 'client-sdk/src/client';
import { GetAllUsersRequestBuilder } from 'client-sdk/src/users/users';
import { GetAllWarehousesRequestBuilder } from 'client-sdk/src/warehouses/warehouses';

// Component
import MapPosition from './mapPosition';
import throttle from 'lodash/throttle';

// Type
import { Warehouse } from '../interfaces';
import { User } from '../../users/interfaces';

// helpers'
import {
  flattenObject,
  removeEmptyValueObject,
} from '../../../utils/helpers';

type Props = {
  data: any;
  update: (body: any) => void;
  partnerId: number;
};

type Inputs = {
  address: string;
  adminId?: number;
  capacity: number;
  centerId?: number;
  city: string;
  id?: number;
  lat: number;
  lon: number;
  name: string;
  parentId?: number;
  phoneNumber: string;
  province: string;
  status?: 'ACTIVE' | 'SUSPENDED';
  workDays: string;
  workTimes: string;
  zipCode?: string;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
  })
);

const autocompleteService = { current: null };
const token = localStorage.getItem('token') || '';

export default function Edit(props: Props) {
  const classes = useStyles();
  const { register, handleSubmit, errors, watch } = useForm<Inputs>();
  const [latLng, setLatLng] = useState({
    lat: props.data.lat,
    lng: props.data.lon,
  } as {
    lat: number;
    lng: number;
  });
  const [openAutocomplete, setOpenAutocomplete] = React.useState(false);
  const [adminId, setAdminId] = useState(props.data?.adminId as number);
  const [options, setOptions] = React.useState<User[]>([]);
  const loading = openAutocomplete && options.length === 0;

  const [
    valueWarehouseParent,
    setValueWarehouseparent,
  ] = React.useState<Warehouse | null>(null);
  const [inputValue, setInputValue] = React.useState('');
  const [optionsWearehouseParent, setOptionsWearehouseParent] = React.useState<
    Warehouse[]
  >([]);

  const loadingWarehouseParent = React.useRef(false);

  if (typeof window !== 'undefined' && !loadingWarehouseParent.current) {
    loadingWarehouseParent.current = true;
  }

  const fetch = React.useMemo(
    () =>
      throttle(
        (
          request: { input: string },
          callback: (results?: Warehouse[]) => void
        ) => {
          const { input } = request;
          (async () => {
            const makeRequest = new GetAllWarehousesRequestBuilder()
              .params({
                'name.contains': input,
                size: 100,
              })
              .build();
            const client = new Client(token);
            const response = await client.execute(makeRequest);
            const warehouse = response.data as any;
            callback(warehouse);
          })();
        },
        200
      ),
    []
  );

  React.useEffect(() => {
    let active = true;
    (async () => {
      const makeRequest = new GetAllWarehousesRequestBuilder()
        .params({
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const warehouse = response.data as any;
      if (active) {
        setOptionsWearehouseParent(warehouse as Warehouse[]);
      }
    })();

    if (!autocompleteService.current) {
    }

    if (inputValue === '') {
      setOptionsWearehouseParent(
        valueWarehouseParent ? [valueWarehouseParent] : []
      );
      return undefined;
    }

    fetch({ input: inputValue }, (results?: Warehouse[]) => {
      if (active) {
        let newOptions = [] as Warehouse[];

        if (valueWarehouseParent) {
          newOptions = [valueWarehouseParent];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptionsWearehouseParent(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [valueWarehouseParent, inputValue, fetch]);

  React.useEffect(() => {
    let active = true;
    if (!loading) {
      return undefined;
    }

    (async () => {
      const token = localStorage.getItem('token') || '';
      const makeRequest = new GetAllUsersRequestBuilder()
        .params({
          'role.equals': 'WAREHOUSE_ADMIN',
          'warehousesId.specified': false,
          size: 100,
        })
        .build();
      const client = new Client(token);
      const response = await client.execute(makeRequest);
      const users = response.data as any;
      if (active) {
        setOptions(users as User[]);
      }
      if (users.length === 0) {
      }
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!openAutocomplete) {
      setOptions([]);
    }
  }, [openAutocomplete]);

  const onSubmit = (data: any) => {
    const { partnerId } = props;
    const {
      address,
      capacity,
      city,
      name,
      phoneNumber,
      province,
      workDays,
      workTimes,
    } = data;
    const { lat, lng } = latLng;
    props.update({
      address,
      capacity,
      city,
      name,
      province,
      workDays,
      workTimes,
      // centerId: valueWarehouseParent?.id || props.data?.canterId,
      partnerId: valueWarehouseParent?.id || props.data?.parentId,
      phoneNumber: phoneNumber.length > 0 ? phoneNumber : null,
      lat,
      lon: lng,
      adminId,
      status: 'ACTIVE',
      id: props.data.id,
    });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={4} alignItems="flex-start">
        <Grid container item xs={6} sm={4} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiAccountOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{ width: '100%' }}>
              <TextField
                fullWidth
                id="name"
                name="name"
                label="نام"
                defaultValue={props.data?.name}
                inputRef={register({ required: true })}
                error={errors.name && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} sm={4} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiPhoneOutline}
                size={1}
                className={classes.icon}
                style={{ transform: 'rotate(-90deg)' }}
              />
            </span>

            <span style={{ width: '100%' }}>
              <TextField
                fullWidth
                id="phoneNumber"
                name="phoneNumber"
                label="شماره موبایل"
                defaultValue={props.data?.phoneNumber}
                inputRef={register({ required: true })}
              // error={
              //   (errors.phoneNumber ||
              //     props.error?.errorKey === 'phoneNumber.duplicate') &&
              //   true
              // }
              // helperText={
              //   errors.phoneNumber
              //     ? 'شماره موبایل وارده نشده است'
              //     : props.error?.errorKey === 'phoneNumber.duplicate' &&
              //       'شماره موبایل وارده شده تکراری است'
              // }
              />
            </span>
          </div>
        </Grid>
        <Grid container item xs={6} sm={4} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCounter} size={1} className={classes.icon} />
            </span>

            <div style={{ width: '100%' }}>
              <TextField
                fullWidth
                id="capacity"
                name="capacity"
                label="ظرفیت"
                defaultValue={props.data?.capacity}
                inputRef={register({ required: true })}
                error={errors.capacity && true}
              />
            </div>
          </div>
        </Grid>

        <Grid container item xs={6} sm={4} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCalendar} size={1} className={classes.icon} />
            </span>

            <div style={{ width: '100%' }}>
              <TextField
                fullWidth
                id="workDays"
                name="workDays"
                label="روزهای فعالیت"
                defaultValue={props.data?.workDays}
                inputRef={register({ required: true })}
                error={errors.workDays && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} sm={4} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon path={mdiCalendarClock} size={1} className={classes.icon} />
            </span>

            <div style={{ width: '100%' }}>
              <TextField
                fullWidth
                id="workTimes"
                name="workTimes"
                label="ساعت فعالیت"
                defaultValue={props.data?.workTimes}
                inputRef={register({ required: true })}
                error={errors.workTimes && true}
              />
            </div>
          </div>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <Grid item xs={1}>
            <Icon path={mdiAccountTieOutline} size={1} />
          </Grid>
          <Grid item xs={11}>
            <Autocomplete
              open={openAutocomplete}
              onOpen={() => {
                setOpenAutocomplete(true);
              }}
              onClose={() => {
                setOpenAutocomplete(false);
              }}
              getOptionSelected={(option, value) => option.name === value.name}
              getOptionLabel={option => option.name}
              options={options}
              loading={loading}
              onChange={(event: any, newValue: any | null) => {
                setAdminId(newValue.id);
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="ادمین انبار"
                  inputRef={register({ required: false })}
                  name="admin"
                  id="admin"
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {loading ? (
                          <CircularProgress color="inherit" size={20} />
                        ) : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
        </Grid>

        <Grid container item xs={4} spacing={1} alignItems="flex-end">
          <Grid item xs={1}>
            <Icon path={mdiAccountTieOutline} size={1} />
          </Grid>
          <Grid item xs={11}>
            <Autocomplete
              id="warehouse-parent"
              getOptionLabel={option =>
                typeof option === 'string' ? option : option.name
              }
              filterOptions={x => x}
              options={optionsWearehouseParent}
              autoComplete
              includeInputInList
              filterSelectedOptions
              value={valueWarehouseParent}
              onChange={(event: any, newValue: Warehouse | null) => {
                setOptionsWearehouseParent(
                  newValue
                    ? [newValue, ...optionsWearehouseParent]
                    : optionsWearehouseParent
                );
                setValueWarehouseparent(newValue);
              }}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              renderInput={params => (
                <TextField
                  {...params}
                  label="انبار والد"
                  variant="standard"
                  fullWidth
                />
              )}
              renderOption={option => {
                return (
                  <Grid container alignItems="center">
                    <Grid item>
                      <Icon path={mdiMapMarkerOutline} size={1} />
                    </Grid>
                    <Grid item xs>
                      {option.name}
                      <Typography variant="body2" color="textSecondary">
                        {option.province}--{option.city}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              }}
            />
          </Grid>
        </Grid>

        <Grid container item xs={6} sm={4} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiHomeCityOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{ width: '100%' }}>
              <TextField
                fullWidth
                id="province"
                name="province"
                label="استان"
                defaultValue={props.data?.province}
                inputRef={register({ required: true })}
                error={errors.province && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={6} sm={4} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiHomeCityOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{ width: '100%' }}>
              <TextField
                fullWidth
                id="city"
                name="city"
                label="شهر"
                defaultValue={props.data?.city}
                inputRef={register({ required: true })}
                error={errors.city && true}
              />
            </div>
          </div>
        </Grid>

        <Grid container item xs={12} alignItems="flex-end">
          <div className={classes.item}>
            <span className={classes.label}>
              <Icon
                path={mdiMapMarkerOutline}
                size={1}
                className={classes.icon}
              />
            </span>

            <div style={{ width: '100%' }}>
              <TextField
                fullWidth
                id="address"
                name="address"
                label="آدرس"
                defaultValue={props.data?.address}
                inputRef={register({ required: true })}
                error={errors.address && true}
              />
            </div>
          </div>
        </Grid>
        <Grid container item xs={12} alignItems="flex-start">
          <div
            className={classes.item}
            style={{ flexDirection: 'column', alignItems: 'flex-start' }}
          >
            <div style={{ display: 'flex' }}>
              <span className={classes.label}>تعیین موقعیت آدرس - </span>
              <span style={{ alignItems: 'flex-end', display: 'flex' }}>
                {' '}
                {latLng.lat
                  ? `${latLng.lat.toFixed(3)} -${latLng.lng.toFixed(3)}`
                  : ''}
              </span>
            </div>

            <div style={{ width: '100%' }}>
              <MapPosition
                zoom={14}
                center={{ lat: props.data.lat, lng: props.data.lon }}
                position={latLng}
                setLatlng={(latLng: { lat: number; lng: number }) => {
                  setLatLng(latLng);
                }}
              />
            </div>
          </div>
        </Grid>
        <Grid item container xs={8}>
          <Button
            fullWidth
            type="submit"
            size="large"
            data-cy="search"
            autoFocus
            variant="contained"
            color="secondary"
            disabled={
              Object.keys(flattenObject(removeEmptyValueObject({ ...watch() })))
                .length === 0
            }
          >
            {`ویرایش اطلاعات`}
          </Button>
        </Grid>
        <Grid item container xs={4}>
          <Button
            fullWidth
            variant="contained"
            // onClick={props.onClose}
            size="large"
            data-cy="search"
          >
            {`انصراف`}
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
